import React, {useState} from 'react';
import { BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import Navbar from './components/navbar/navbar.js';
import Home from './components/home/home.js';
import About from './components/about/about.js';
import Contact from './components/contact/contact.js';
import Menu from './components/menu/menu.js';
import MenuCategory from './components/menu/menuCategory.js';
import SpecificOrderInfo from './components/orderinfo/orderinfo.js';
import Panel from './components/panel/panel.js';
import './App.css';
import {Helmet} from "react-helmet";
import Technical from './components/technical/technical.js';


function App() {
	
  return (
    <div className="App">
		<Helmet>
			<html lang="he" />
			<meta name="google-site-verification" content="5n9c9PqrmkD2N24HPlupTNhOdFzuuGFjNvsvpHKCkic" />
			<title>המסעדה של איתי שיף ©</title>
			<meta charset="UTF-8" />
			<meta name="author" content="איתי שיף" />
			<meta name="robots" content="index, follow"/>
			<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
			<meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"/>
			<meta 
			name="description" 
			content="© המסעדה של איתי שיף | הכל בפתרון אחד - eCommerce, מערכת ניהול תוכן, ניהול קשרי לקוחות, משלוחים במעקב לייב, SEO ממוטב, אתר דינמי ומעוצב אישית." />
			<meta name="keywords" content="front-end developer, front-end development, web designer, restaurant, e-commerce, cms, crm, dynamic website, firebase"/>
		</Helmet>

    	<BrowserRouter>
			
			<Navbar/>

				<Switch>
					<Route exact path='/' component={Home}/>
					<Route exact path='/about' component={About}/>
					<Route exact path='/menu' component={Menu}/>
					<Route exact path='/menu/:category' component={MenuCategory}/>*/
					<Route exact path='/contact' component={Contact}/>
					<Route exact path='/panel' component={Panel}/>
					<Route exact path="/order/:id" component={SpecificOrderInfo}/>
					<Route exact path="/technical" component={Technical}/>

					{/* FOR ENGLISH */}
					<Route exact path='/en' component={Home}/>
					<Route path='/en/about' component={About}/>
					<Route exact path='/en/menu' component={Menu}/>
					<Route path='/en/menu/:category' component={MenuCategory}/>*/
					<Route path='/en/contact' component={Contact}/>
					<Route path='/en/panel' component={Panel}/>
					<Route path="/en/order/:id" component={SpecificOrderInfo}/>
					<Route path="/en/technical" component={Technical}/>

					{/* Conditional redirect, based on the URL, if it contains /en/ and it didn't match one of the about, then redirect to "/en", else just send to english page*/}
					{window.location.href.includes('/en/') ? <Redirect to="/en"/> : <Redirect to="/" /> } 
					
				</Switch>	
	  	</BrowserRouter>

		

    </div>
  )
}

export default App;
